import React from 'react';
import Tooltip from '@aseda_library/ui/Tooltip';
import useHelpResources from './useHelpResources';
import DataSaveIcon from '@components/icons/dataSave.icon';
import { DocumentIconLink } from '@as_core/styles/elementStyles';

interface PropsI {
  s3Ref: string;
  inNewTab?: boolean;
}

const debug = false;
const DownloadFileFromS3Ref = (props: PropsI) => {
  const {s3Ref, inNewTab=false} = props;
  if (debug) console.log(`DownloadFileFromS3Ref | s3Ref: ${s3Ref} inNewTab: ${inNewTab}`);
  const { getS3Url } = useHelpResources();

  const handleDownload = async () => {
    if (debug) console.log(`DownloadFileFromRef.handleDownload | s3Ref: ${s3Ref}`);
    const s3_url = await getS3Url(s3Ref);
    const file_name = s3Ref.split('/').pop();
    const link = document.createElement('a');
    if (debug) console.log(s3_url, file_name);
    if (inNewTab) {
      window.open(s3_url, '_blank');
    } else {
      link.href = s3_url;
      link.download = file_name;
      link.click();
    }
  }

  if (!s3Ref) return null;

  return (
    <Tooltip
      key={`s3_download_tooltip_${s3Ref}`}
      title={inNewTab ? 'Download file in new tab' : 'Download file to browser downloads'}
      placement={'bottom-start'}
      arrow
    >
      <DocumentIconLink
        key={`file_${s3Ref}`}
        onClick={() => handleDownload()}
        isActive={true}
      >
        <DataSaveIcon />
      </DocumentIconLink>
    </Tooltip>
  );
};

export default DownloadFileFromS3Ref;
